import { Injectable } from '@angular/core';
import { MatomoRouterInterceptor, MatomoTracker } from 'ngx-matomo-client';
import { KeycloakService } from 'keycloak-angular';

@Injectable()
export class MatomoAuthInterceptor implements MatomoRouterInterceptor {
  constructor(
    private readonly tracker: MatomoTracker,
    private readonly keycloak: KeycloakService
  ) {}

  async beforePageTrack(): Promise<void> {
    const isAuthenticated = await this.keycloak.isLoggedIn();

    // Set a custom dimension for authentication status
    // Note: You need to configure this dimension ID in your Matomo admin panel first
    this.tracker.setCustomDimension(
      1,
      isAuthenticated ? 'authenticated' : 'anonymous'
    );
  }
}
